/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.11.0
 * @since 1.0.0
 */

import { ChangeEvent, FormEvent } from 'react';

import { people } from '../../../../assets/icons';
import { BlockWithIcon, Button, Input, LinkBlock, PasswordInput } from '../../../../components/common';
import { EInputKind } from '../../../../components/common/Input/Input';
import GTMOperations from '../../../../modules/analytics/GoogleTagManager/GTMOperations';
import Captcha from '../../../../modules/captcha/components/Captcha';
import { useAuthContext } from '../../PageAuthProvider';
import {
    FormContainerStyled,
    FormGroupStyled,
    FormSubtitleStyled,
    FormTitleStyled,
    FormWrapperStyled,
} from '../../styled/PageAuthStyled';

export interface IAuthFormProps {
    inputHandler: (event: ChangeEvent<HTMLInputElement>, field: string) => void;
    isCaptchaShouldBeShown: boolean;
    showCaptcha?: boolean;
    submitHandler: (event: FormEvent) => void;
    validForm: boolean;
}

const AuthForm = (props: IAuthFormProps) => {
    // get auth context
    const { isServiceUser, translation } = useAuthContext();

    return <FormContainerStyled>
        <FormWrapperStyled
            className="login-form"
            onSubmit={props.submitHandler}
        >
            <FormTitleStyled>{translation.form.title}</FormTitleStyled>
            <FormSubtitleStyled>{translation.form.subTitle}</FormSubtitleStyled>
            <FormGroupStyled className="form-group__login-input">
                <Input
                    data-input-login="loginAuthform"
                    kind={props.validForm ? EInputKind.normal : EInputKind.error}
                    label={translation.form.labelLogin}
                    name="username"
                    onChange={(e: ChangeEvent<HTMLInputElement>) => props.inputHandler(e, 'login')}
                />
            </FormGroupStyled>
            <FormGroupStyled className="form-group__password-input">
                <PasswordInput
                    data-input-pwd="passwordAuthform"
                    kind={props.validForm ? EInputKind.normal : EInputKind.error}
                    label={translation.form.labelPassword}
                    name="password"
                    onChange={(e: ChangeEvent<HTMLInputElement>) => props.inputHandler(e, 'password')}
                />
            </FormGroupStyled>
            {
                !isServiceUser &&
                <FormGroupStyled>
                    <LinkBlock
                        data-link-recovery="passwordForget"
                        url="/login/recovery"
                        onClick={GTMOperations.auth.onForgetPasswordClickOperation}>
                        {translation.form.passwordForget}
                    </LinkBlock>
                </FormGroupStyled>
            }
            <FormGroupStyled>
                {
                    props.isCaptchaShouldBeShown && <Captcha
                        translation={{
                            label: translation.form.captcha,
                        }}/>
                }

            </FormGroupStyled>
            <FormGroupStyled style={{ paddingTop: '10px' }}>
                <Button dataName="buttonSubmitAuthform" kind="medium">{translation.form.buttonSubmit}</Button>
            </FormGroupStyled>
        </FormWrapperStyled>
        <BlockWithIcon
            data-text-with-icon="howToGetAccess"
            iconRight={people}
            iconRightSize={64}
            justifyContent="flex-end"
        />
    </FormContainerStyled>;
};

export default AuthForm;
